import ResetPasswordInitialStep from './Steps/ResetPasswordInitialStep';
import ResetPasswordSuccessStep from './Steps/ResetPasswordSuccessStep';
import ResetPasswordSetNewStep from './Steps/ResetPasswordSetNewStep';
import ResetPasswordSetNewSuccessStep from './Steps/ResetPasswordSetNewSuccessStep';

export const steps = [
  {
    stepId: 1,
    Component: ResetPasswordInitialStep,
  },
  {
    stepId: 2,
    Component: ResetPasswordSuccessStep,
  },
  {
    stepId: 3,
    Component: ResetPasswordSetNewStep,
  },
  {
    stepId: 4,
    Component: ResetPasswordSetNewSuccessStep,
  },
];
